import { SavedSortResource } from "@models/resource/saved-sort.resource";
import { SavedSortView } from "@models/ui/saved-sort-view.model";
import { MapperBase } from "@utilities/mapper-base";

export class SavedSortResourceToSavedSortViewMapper extends MapperBase<SavedSortResource, SavedSortView>{
    public map(source: SavedSortResource): SavedSortView {
        const dest = new SavedSortView();
        dest.sortId = source.sortId;
        dest.caseId = source.caseId;
        dest.createdByUserId = source.createdByUserId;
        dest.createdDateTime = source.createdDateTime;
        dest.displayTitle = source.displayTitle;
        dest.sortDetails = {
            first: {
              fieldId: source.sortDetails.first.fieldId,
              direction: mapEnumToString(source.sortDetails.first.direction),
            },
            second: {
              fieldId: source.sortDetails.second.fieldId,
              direction: mapEnumToString(source.sortDetails.second.direction),
            },
            third: {
              fieldId: source.sortDetails.third.fieldId,
              direction: mapEnumToString(source.sortDetails.third.direction),
            }
          };
        return dest;
    }
}

function mapEnumToString(direction: number): "ASC" | "DESC" {
    switch (direction) {
      case 0: return "ASC";  // ascending
      case 1: return "DESC"; // descending
      default: throw new Error(`Unknown sort direction: ${direction}`);
    }
  }